{
  "schema_version": 1,
  "task_id": "L5-CLOUD-SYNC-ACTIVATION-DOR-001",
  "status": "dor-only",
  "authority_boundary": {
    "dor_only": true,
    "activation_enabled": false,
    "real_account_connected": false,
    "network_access": false,
    "cloud_read": false,
    "cloud_write": false,
    "oauth_flow": false,
    "secret_required_now": false,
    "secret_storage": false,
    "runtime_activation": false,
    "model_call": false,
    "external_write": false,
    "paid_action": false,
    "task_completion_authority": false
  },
  "activation_readiness": [
    {
      "id": "provider-choice",
      "title_zh": "用户选择同步提供方",
      "title_en": "User-selected sync provider",
      "current_state": "blocked",
      "required_before_activation": [
        "provider_id selected by user",
        "storage class and region understood",
        "cost and quota accepted by user",
        "rollback route available"
      ],
      "forbidden_shortcut": "default provider auto-selection"
    },
    {
      "id": "account-oauth-scope",
      "title_zh": "账号与 OAuth Scope 边界",
      "title_en": "Account and OAuth scope boundary",
      "current_state": "blocked",
      "required_before_activation": [
        "exact account identity confirmed by user",
        "minimal OAuth scopes listed",
        "token custody and revocation documented",
        "non-echo secret channel used"
      ],
      "forbidden_shortcut": "broad scope OAuth or copied chat secrets"
    },
    {
      "id": "secret-boundary",
      "title_zh": "Secret 托管边界",
      "title_en": "Secret custody boundary",
      "current_state": "blocked",
      "required_before_activation": [
        "no secret committed to Git",
        "ignored local or provider secret store only",
        "rotation and deletion path documented",
        "secret scan passes after setup"
      ],
      "forbidden_shortcut": "plain-text token in source, Evidence or chat transcript"
    },
    {
      "id": "data-scope",
      "title_zh": "同步数据范围",
      "title_en": "Sync data scope",
      "current_state": "blocked",
      "required_before_activation": [
        "allowlisted project state sources",
        "explicit binary and artifact exclusions",
        "maximum object size limit",
        "no target/node_modules/runtime log mirroring"
      ],
      "forbidden_shortcut": "unbounded workspace scan"
    },
    {
      "id": "conflict-no-clobber",
      "title_zh": "冲突与无覆盖策略",
      "title_en": "Conflict and no-clobber policy",
      "current_state": "blocked",
      "required_before_activation": [
        "source snapshot hash",
        "target snapshot hash or etag",
        "operation idempotency key",
        "human-visible diff for conflict",
        "manual conflict required for both-changed state",
        "no last-write-wins default"
      ],
      "forbidden_shortcut": "silent overwrite or background retry without receipt"
    },
    {
      "id": "observable-run-protocol",
      "title_zh": "可观测长任务协议",
      "title_en": "Observable run protocol",
      "current_state": "blocked",
      "required_before_activation": [
        "stable run_id",
        "progress.json or progress.jsonl",
        "stdout and stderr logs",
        "activity age threshold",
        "timeout and cancellation semantics",
        "receipt.json or invalid.json terminal file"
      ],
      "forbidden_shortcut": "status=running without activity evidence"
    },
    {
      "id": "rollback-recovery",
      "title_zh": "回滚与恢复",
      "title_en": "Rollback and recovery",
      "current_state": "blocked",
      "required_before_activation": [
        "pre-write local snapshot",
        "provider-side rollback reference",
        "dry-run proof before write",
        "post-write verification",
        "manual recovery instructions"
      ],
      "forbidden_shortcut": "write-first activation"
    },
    {
      "id": "independent-review",
      "title_zh": "独立复审",
      "title_en": "Independent review",
      "current_state": "blocked",
      "required_before_activation": [
        "Task Spec reviewed",
        "Evidence reviewed",
        "rollback reviewed",
        "secret boundary reviewed",
        "no-clobber policy reviewed"
      ],
      "forbidden_shortcut": "self-approved cloud activation"
    }
  ],
  "activation_sequence": [
    {
      "phase": "A",
      "name": "local-dry-run",
      "status": "future-task",
      "allowed_effect": "local receipt only"
    },
    {
      "phase": "B",
      "name": "live-readonly-probe",
      "status": "requires-user-account-approval",
      "allowed_effect": "bounded metadata read only"
    },
    {
      "phase": "C",
      "name": "single-object-no-clobber-write-canary",
      "status": "requires-separate-task-spec",
      "allowed_effect": "one explicitly scoped test object only"
    },
    {
      "phase": "D",
      "name": "limited-sync-beta",
      "status": "requires-reviewer-and-rollback-pass",
      "allowed_effect": "allowlisted state objects only"
    }
  ],
  "current_decision": {
    "can_activate_now": false,
    "reason": "DoR is defined but all activation readiness gates are blocked pending user provider/account choice and future Evidence.",
    "next_safe_task": "L5-SYNC-READINESS-UI-SURFACE-001"
  }
}

